/**
 * Owner: Masa Bayu
 * File: use-hub-cover.ts
 * Date:Time: 2026-10-25 13:20
 * Description: COVER-A3 — hook cover untuk kad buku: pulangkan dataURL cover
 *   hub yang sudah dimuat, muat malas bila lokasi tersedia, null = tiada cover.
 */

import { useEffect, useState } from 'react';
import { cachedHubCoverDataUrl, loadHubCover, subscribeHubCovers } from '../publication/hub-covers';

export function useHubCoverSrc(publicationId: string): string | null {
  const [src, setSrc] = useState<string | null>(() => cachedHubCoverDataUrl(publicationId));

  useEffect(() => {
    let alive = true;
    const read = (): void => {
      if (alive) setSrc(cachedHubCoverDataUrl(publicationId));
    };
    const refresh = (): void => {
      read();
      void loadHubCover(publicationId).then(read);
    };
    const unsubscribe = subscribeHubCovers(refresh);
    refresh();
    return () => {
      alive = false;
      unsubscribe();
    };
  }, [publicationId]);

  return src;
}
